export const getIsStoreLocatorModalInitialized = ({ storeLocatorModal }) =>
  storeLocatorModal.initialized
